import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import { actionEditWebmasterProfileSuccess } from '../../webmaster/actions/profile';

import {
  ACTION_LOAD_FISCAL_NUMBER__REQUEST,
  ACTION_LOAD_FISCAL_NUMBER__SUCCESS,
  ACTION_LOAD_FISCAL_NUMBER__FAIL,

  ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__REQUEST,
  ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__SUCCESS,
  ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__FAIL,

  ACTION_EDIT_CORPORATION_FISCAL_NUMBER__REQUEST,
  ACTION_EDIT_CORPORATION_FISCAL_NUMBER__SUCCESS,
  ACTION_EDIT_CORPORATION_FISCAL_NUMBER__FAIL,
} from '../actionTypes';


const actionLoadFiscalNumberSuccess = fiscalNumber => ({
  type: ACTION_LOAD_FISCAL_NUMBER__SUCCESS,
  payload: { fiscalNumber },
});

const actionLoadFiscalNumberFail = error => ({
  type: ACTION_LOAD_FISCAL_NUMBER__FAIL,
  payload: { error },
});

export const actionLoadFiscalNumberRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_FISCAL_NUMBER__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/payout_settings/fiscal_number'
    ).then(
      ({ profile, vat, tax }) => {
        dispatch(actionLoadFiscalNumberSuccess({ vat, tax }));
        dispatch(actionEditWebmasterProfileSuccess(profile));
      },
      error => {
        dispatch(actionLoadFiscalNumberFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionEditIndividualFiscalNumberSuccess = fiscalNumber => ({
  type: ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__SUCCESS,
  payload: { fiscalNumber },
});

const actionEditIndividualFiscalNumberFail = error => ({
  type: ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__FAIL,
  payload: { error },
});

export const actionEditIndividualFiscalNumberRequest = (
  vatNumber,
  taxNumber,
  firstname,
  lastname
) => (
  (dispatch, getState, { apiClientHelper }) => {
    const data = {
      vat: vatNumber,
      tax: taxNumber,
      firstname,
      lastname,
    };
    dispatch({
      type: ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__REQUEST,
      payload: data,
    });

    return apiClientHelper.post(
      '/rest/webmaster/payout_settings/fiscal_number/individual',
      { data }
    ).then(
      ({ profile, vat, tax }) => {
        dispatch(actionEditIndividualFiscalNumberSuccess({ vat, tax }));
        dispatch(actionEditWebmasterProfileSuccess(profile));
      },
      error => {
        dispatch(actionEditIndividualFiscalNumberFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionEditCorporationFiscalNumberSuccess = fiscalNumber => ({
  type: ACTION_EDIT_CORPORATION_FISCAL_NUMBER__SUCCESS,
  payload: { fiscalNumber },
});

const actionEditCorporationFiscalNumberFail = error => ({
  type: ACTION_EDIT_CORPORATION_FISCAL_NUMBER__FAIL,
  payload: { error },
});

export const actionEditCorporationFiscalNumberRequest = vatNumber => (
  (dispatch, getState, { apiClientHelper }) => {
    const data = { vat: vatNumber };
    dispatch({
      type: ACTION_EDIT_CORPORATION_FISCAL_NUMBER__REQUEST,
      payload: data,
    });

    return apiClientHelper.post(
      '/rest/webmaster/payout_settings/fiscal_number/corporation',
      { data }
    ).then(
      ({ vat, tax, profile }) => {
        dispatch(actionEditCorporationFiscalNumberSuccess({ vat, tax }));
        dispatch(actionEditWebmasterProfileSuccess(profile));
      },
      error => {
        dispatch(actionEditCorporationFiscalNumberFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
